import React, {useState} from 'react';
import TitleWithIcon from './TitleWithIcon'
import VisDiv from './frontend_components/VisDiv';
import { AiFillPlusCircle } from 'react-icons/ai';
import {useStateContext} from '../context/StateContext';
import ModalContent from './ModalContent';
import NewDeviceField from './NewDeviceField';
import TextField from './TextField';
import { v4 as uuidv4, v4 } from 'uuid';
import RegisterIcon from './RegisterIcon';
import { useCreateReplace } from '../hooks/mutations';
import useNetworkStatus from '../hooks/useNetworkStatus';
import useNetwork from '../hooks/useNetwork';
import { successAlert,errorAlert, keyId, registerLabelAndName  } from '../lib/utils';
import { useQueryClient } from '@tanstack/react-query';
import { clientUser, facilityClient } from '../lib/userPermissions';
import TrueFalseToggle from './TrueFalseToggle';
import TestButton from './frontend_components/TestButton';
import FieldDropdown from './FieldDropdown';
import { useEffect } from 'react';
import { deviceNonConformityDoc, referenceDoc } from './gestioneDatabase/Docs';
import { key } from 'localforage';



/**
 * SliderRegistri component for managing registers in the registers system.
 * Handles device creation, editing, substitution, archival and maintenance operations.
 * #registers
 * 
 * @param {Object} props Component props
 * @param {Array} props.registers Array of register objects containing devices
 * @param {boolean} props.showArchived Whether to show archived registers
 * @param {Array} props.registersAsTemplates Array of register objects containing devices, used as templates
 * @param {Array} props.templates Array of template objects containing device configurations
 * @param {Function} props.setLoading Function to set loading state
 * @param {boolean} props.hideTemplates Whether to hide the templates panel
 * @param {Function} props.closeAllInfo Function to close all info panels
 * @returns {JSX.Element} Register management interface
 */
const SliderRegistri = ({registers, showArchived, registersAsTemplates, templates, setLoading, hideTemplates, closeAllInfo=()=>{}}) => {

    const {
        site,
        register,
        client,
        setRegister,
        setCurrentTemplate,
        setRegisters,
        sUser,
        LDB

    } = useStateContext();


    const networkStatus = useNetworkStatus()


    const [selectedTemplate, setSelectedTemplate ] = useState(undefined)
    const testing = false



    const testFunction = () => {
        console.log(orderedRegisters)
        //console.log("tamplates", templates)
    }
    


    const addRegister = (template, currentSite) => {
        //console.log("add register:",template);
        //console.log("registers", registers);
        //console.log("tamplates", templates);        
        //console.log("current site", currentSite);
        setSelectedTemplate(template)
        //setCurrentTemplate(template)
    }

        

    const setCurrentRegister = (registerIcon, template) => {
        setLoading(true)
        //console.log("set register:",registerIcon)
        //console.log("current register", register)
        setCurrentTemplate(template)
        setRegister(registerIcon)
        closeAllInfo()
        //window.location.reload(false);
        setLoading(false)
    }


    
    const isActive = (registerIcon) => {
        if(registerIcon?._id == register?._id) return true
        return false
    }

    const registerTemplateData = (registerIcon) => !Array.isArray(templates) ? undefined : templates?.find?.((x)=>x._id==registerIcon?.template?._ref)

    const selectRegister = (register, currentRegister) => {
        if(register?._id == currentRegister?._id){
            //console.log("CLICKED SAME REGISTER")
            setRegister(undefined)
            closeAllInfo()
        }
        else {
            setCurrentRegister(register, registerTemplateData(register));
            //console.log("selected register", register)
        }

    }
    function compare( a, b ) {
        if ( a?.order < b?.order ){
          return -1;
        }
        if ( a?.order > b?.order ){
          return 1;
        }
        return 0;
      }
    const registersArray = registers?.length > 0 ? registers : []  
    const orderedRegisters = !Array.isArray(registersArray) ? [] : registersArray?.map?.((item)=>{
        const template = !Array.isArray(templates) ? undefined : templates?.find?.(x=>x?._id==item?.template?._ref) 
        //console.log(template?.order)
        return ({...item, order:template?.order })
        }) 

    const iconOpacity = (item) => {
        if(item?.status == "ARCHIVIATO") return 0.5
        if(item?.notInMaintenance) return 0.3
        return 1

    }
    const iconOverlay = (item) => {
        //if(item?.notInMaintenance) return 0.7
        return {}
    }

  return (
    <>
    <div className='horizontal-swipe-wrapper' style={{marginTop:"10px"}}>
        
        {registers && (!Array.isArray(registers) ? [] : orderedRegisters.sort(compare).filter?.(x=>{
        if(showArchived) return x
        return x?.status !== "ARCHIVIATO"
        })
        ?.map?.((item)=>(
            <div key={item._id} className='horizontal-swipe-box' style={{backgroundColor:"", opacity: iconOpacity(item)}}> 
                <RegisterIcon archived = {item?.status == "ARCHIVIATO"} currentRegister={register} template={registerTemplateData(item)} templates={templates} register={item} additionalTitle={item?.registerName} onClick={()=>selectRegister(item, register)}/> 
            </div>
        )))}
        <VisDiv rules={[registers?.length>0, networkStatus, clientUser(sUser), facilityClient(client, sUser), !hideTemplates]} style={{borderRight: "1px solid grey", height:"50px", marginRight:"18px"}}></VisDiv>

            {templates?.length > 0 && (!Array.isArray(templates) ? [] : templates?.filter?.(x=>x?.status !== "ARCHIVIATO").sort(compare).map?.((item)=>(
                <VisDiv rules={[networkStatus, !hideTemplates, clientUser(sUser), facilityClient(client, sUser) ]} key={item._id} className='horizontal-swipe-box' style={{backgroundColor:"",}}> 
                    <RegisterIcon template={item} additionalTitle={LDB("misc", "template")} templates={templates} onClick={()=>addRegister(item, site)}/> 
                </VisDiv>
          )))}
     
    </div>
    <VisDiv rules={[testing]}><button onClick={testFunction}>test</button></VisDiv>
    <VisDiv rules={[selectedTemplate]}>
        <AddName setSelectedTemplate={setSelectedTemplate} template={selectedTemplate} closeAllInfo={closeAllInfo} registersAsTemplates={registersAsTemplates} site={site}/>
    </VisDiv>
    
    </>
  )
}

export default SliderRegistri


 export const AddName = ({template, site, setSelectedTemplate, registersAsTemplates, closeAllInfo=()=>{}}) => {

        const {
        register,
        client,
        setRegister,
        setCurrentTemplate,
        setRegisters,
        sUser,
        LDB

    } = useStateContext();


        const registersAsTemplatesArray = !Array.isArray(registersAsTemplates) ? [] : registersAsTemplates?.filter?.(x=>x?.template?._ref == template?._id)   
        const queryClient = useQueryClient()
        const [disableContinue, setDisableContinue] = useState(false)
        const [nameValue, setNameValue] = useState("")
        const [checkResetDays, setCheckResetDays] = useState(120)
        const [notInMaintenance, setNotInMaintenance] = useState(false)
        const [addEmpty, setAddEmpty] = useState(false)
        const [devices, setDevices] = useState([])
        const continueDisabledColor = disableContinue && "grey"
        const [registerAsTemplate, setRegisterAsTemplate] = useState()

        const updateFieldKeys = (field, device) => {
            if(!field) return []
            if(!device) return []
            return !Array.isArray(device[field]) ? [] : 
                device[field]?.map?.((item)=>{
                    return (
                        {...item, 
                        values: !Array.isArray(item?.values) ? [] : item?.values?.map((value)=>({...value, _key: keyId()})),
                        _key: keyId(), 

                        }
                    )
                })
            }

        const updateFromRegisterAsTemplate = (registerAsTemplate) => {
                setRegisterAsTemplate(registerAsTemplate)
                setCheckResetDays(registerAsTemplate?.checkResetDays)
                setDevices(!Array.isArray(registerAsTemplate?.devices) ? [] : 
                    registerAsTemplate?.devices?.map((device)=>{
                        const newDeviceDoc = {
                            ...device, 
                            nonConformities: !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities?.map((nc)=>{
                                return deviceNonConformityDoc(nc?.nonConformity?._ref, sUser)
                            }),
                            locations: updateFieldKeys("locations", device),
                            fields: updateFieldKeys("fields", device),
                            dates: updateFieldKeys("dates", device),
                            substituteFields: updateFieldKeys("substituteFields", device),
                            userLog: [{
                                _id: uuidv4(),
                                _key: keyId(),
                                _type: "userLog",
                                date: Date.now(),
                                logType: "created",
                                postedBy: referenceDoc(sUser?._id)
                            }],
                            _key: keyId(), 
                            _id: uuidv4(), 
                            _updatedAt: Date.now()
                        }
                        return newDeviceDoc
                    })
                )
        }

        useEffect(()=>{
            if(!registerAsTemplate && registersAsTemplatesArray?.length > 0){
                //console.log("makldmaskldmawkldm adding template data", registersAsTemplatesArray[0])
                updateFromRegisterAsTemplate(registersAsTemplatesArray[0])

            }


        },[registersAsTemplatesArray])


        const doc = {
            label: template?.family, 
            devices: addEmpty ? []  : devices,
            _key: keyId(),
            _id: uuidv4(),
            _type:"register",
            notInMaintenance: notInMaintenance,
            checkResetDays: Number(checkResetDays),
            postedBy: [{ _type: 'postedBy', _ref: sUser._id,  _key: keyId()}],
            site: {
                _ref:site?._id,
                _type:"reference",
                _key: keyId(),
            },
            template: {
                _ref:template?._id,
                _type:"reference",
                _key: keyId(),
            },
            registerName: nameValue,
            status: "ATTIVO"
        }
        const {mutate: insertRegister} = useCreateReplace({
       
                onMutate: async (newDoc) => {

                    await queryClient.cancelQueries({ queryKey: ['registers', site] })
                    const previousRegisters = queryClient.getQueryData(['registers', site])
            
                    const doc = newDoc?.doc
                    
                    queryClient.setQueryData(['registers', site], (old) =>{ 
                        //const registerTemplate = !Array.isArray(templates) ? undefined : templates?.find?.(x=>x?._id == newDoc?.template?._ref) 
                        const oldData = old?.length > 0 ? (!Array.isArray(old) ? [] : old) : []
                        const newData = [...oldData?.filter?.(x=>x?._id!== doc?._id), doc]
                        //selectRegister(doc)
                        setRegisters(newData)
                        //setRegister(doc)
                        //setCurrentTemplate(registerTemplate)
                        //setSelectedTemplate(registerTemplate)
                        
                        return newData
                    })
                    return { previousRegisters, register}
                },
                onError: (err, newDoc, context) => {
                    errorAlert("CREAZIONE REGISTRO NON RIUSCITO, RIPROVA")
                    queryClient.setQueryData(['registers', site], context?.previousRegisters)
                    setRegisters(context.previousRegisters)
                    setRegister(undefined)
                    closeAllInfo()
                    setCurrentTemplate(undefined)
                    
                    console.error('Oh no, the update failed: ', err?.message)
                    
                },
                onSuccess: (data) => {
                    
                    successAlert("REGISTRO CREATO CON SUCCESSO")
                    setRegister(data)
                    setCurrentTemplate(template)
                    closeAllInfo()
                    setSelectedTemplate("")
                }
    
    })

        const onContinue = () => {
         insertRegister({doc})
        }
        
        const consoleData = {registersAtTemplatesArray: registersAsTemplatesArray, registersAsTemplates, template, site, doc}
        return (
        
        <div className={"selector"}>
            {`${LDB("index", "addNewRegister")} ${template?.family} IN ${site?.label}`}
            <TestButton consoleData={consoleData} buttonId={"1poekp1o2ekop12ke"} message={"CREA REGISTRO"} />
                <NewDeviceField label={LDB("index","addRegisterName")}> 
                    <TextField
                    //onSelect={()=>setDisableContinue(true)} 
                    onChange={(e) => setNameValue(e.target.value)}
                    //onBlur={()=>{
                        //setDisableContinue(false)
                    // }} 
                    />
                    <VisDiv rules={[registersAsTemplatesArray?.length > 0]}>
                        <TrueFalseToggle 
                            value={addEmpty}
                            onClick={()=> {
                                
                                if(addEmpty){
                                   setAddEmpty(false)
                                   updateFromRegisterAsTemplate(registerAsTemplate || registersAsTemplatesArray[0])

                                } else {
                                    setCheckResetDays(120)
                                    setDevices([])
                                    setAddEmpty(true)
                                }
                            }
                            }
                            label={"AGGIUNGI VUOTO"}
                            descriptionDivider={false}
                            description={"Aggiungi un nuovo dispositivo vuoto, senza presidi di default"}
                        />
                    </VisDiv>
                    <VisDiv rules={[registersAsTemplatesArray?.length > 1]}>
                        <FieldDropdown
                            options={registersAsTemplatesArray?.map?.((x) => ({
                                ...x,
                                value: x?._id,
                                label: registerLabelAndName(x),
                            }))}
                            initialValue={!registerAsTemplate ? {} : {...registerAsTemplate, value: registerAsTemplate?._id, label: registerLabelAndName(registerAsTemplate)}}
                            isMulti={false}
                            onChange={(value) => {
                                updateFromRegisterAsTemplate(value)
                            }}
                        />
                    </VisDiv>
                    
                    <TextField 
                        value={checkResetDays} 
                        label={"GIORNI DI CHECK RESET"}
                        type='number'
                        onChange={(e) => setCheckResetDays(e.target.value)} 
                        //description={"Inserire un email per creare un nuovo utente o per duplicare uno esistente."} 
                        descriptionDivider={false}
                    />
                    <TrueFalseToggle 
                        value={notInMaintenance}
                        onClick={()=>setNotInMaintenance(!notInMaintenance)}
                        label={"NON IN MANUTENZIONE"}
                    />
                </NewDeviceField> 
                <div style={{display:"flex", justifyContent:"center"}}>
                    <div className="new-register">
                        <div className="footer">
                            <button
                                onClick={() => {
                                setSelectedTemplate("");
                                }}
                                id="cancelBtn"
                            >
                                {LDB("misc","cancel")}
                            </button>
                            <button style={{backgroundColor: continueDisabledColor}} disabled={disableContinue} onClick={onContinue}>{LDB("misc","save")}</button>
                        </div>
                    </div>
                </div> 
        </div>
   ) }